import React, { useEffect, useState } from 'react';
import { Grid, Box, CircularProgress } from '@material-ui/core';
import logo from '../../assets/images/logos/Keyboarding-Online-Lab-Logo_Sign-In-Page.svg';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { Typography } from '@mui/material';
import { toastError } from '../../utils/toast';
import mainLogo from '../../assets/images/logos/Paradigm-Logo_Sign-In-Page.svg';
import moodleAxios from '../../services/moodle/moodleApi';
import { useUserContext } from '../../UserProvider';
import { token } from 'utils/baseURLs';

// import ReactLoading from 'react-loading';

let primShadow = `inset 2px 2px 5px #babecc, inset -5px -5px 10px #fff`;
let secShadow = `inset 0.2rem 0.2rem 0.5rem rgb(253, 103, 103),
    inset -0.2rem -0.2rem 0.5rem rgb(247, 15, 15), 0.3rem 0.3rem 0.5rem rgb(238, 79, 79),
    -0.2rem -0.2rem 0.4rem rgb(248, 61, 61)`;
let onFocusShadow = `inset 0.2rem 0.2rem 0.5rem rgb(195 193 198 / 90%), inset -0.2rem -0.2rem 0.5rem #fff,
    0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff`;

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isValidPassword, setIsValidPassword] = useState(true);
  const { setUserContext } = useUserContext();
  const [emailcolor, setEmailColor] = useState({
    boxShadow: primShadow
  });
  const [passcolor, setPassColor] = useState({
    border: 'none',
    boxShadow: primShadow
  });

  const [logincred, setLogincred] = useState(false);
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'production') {
      window.addEventListener('contextmenu', e => {
        e.preventDefault();
      });
      window.addEventListener(
        'keydown',
        function (e) {
          if (e.keyCode == 123) {
            e.preventDefault();
          }
          if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
            e.preventDefault();
          }
        },
        false
      );
    }
  }, []);
  if (sessionStorage.getItem('token') != null) {
    navigate('/dashboard');
  }
  const baseURL = `/login/token.php?service=moodle_mobile_app&username=${email}&password=${password}`;

  const onFormSubmit = () => {
    if (email === '') {
      toastError('Email is not valid..');
      return;
    } else if (!(password.trim().length > 1)) {
      setIsValidPassword(false);
      toastError('Password field cannot be empty..');
      setPassColor(prev => {
        let state = prev;
        state.border = '.3px solid red';
        state.boxShadow = secShadow;
        return state;
      });
      return;
    } else {
      setLogincred(true);

      setIsValidPassword(true);
      moodleAxios
        .post(baseURL, {
          service: 'moodle_mobile_app',
          username: email,
          password: password
        })
        .then(function (response) {
          if (response.status == 200) {
            // console.log(response.data);
            // console.log(typeof response.data.token);
            const userid = response.data.userid;
            const userdataURL = `/webservice/rest/server.php?wstoken=${token}&wsfunction=core_user_get_users&moodlewsrestformat=json&criteria[0][key]=id&criteria[0][value]=${userid}`;

            // const userdataURL = `/webservice/rest/server.php?wstoken={process.env.REACT_APP_MOODLE_Token}&wsfunction=core_user_get_users&moodlewsrestformat=json&criteria[0][key]=id&criteria[0][value]=${userid}`;
            if (response.data.token != undefined || response.data.userid != undefined) {
              const config = {
                token: response.data.token,
                userid: response.data.userid
              };
              moodleAxios.get(userdataURL).then(function (userData) {
                // console.log(userData.data);
                sessionStorage.setItem('token', config.token);
                sessionStorage.setItem('userid', config.userid);
                localStorage.setItem(
                  'UserData',
                  JSON.stringify({ userData: userData.data.users[0] })
                );
                setUserContext(() => userData.data.users[0]);
                sessionStorage.setItem('department', userData.data.users[0].department);
                sessionStorage.setItem('description', userData.data.users[0].description);
                sessionStorage.setItem(
                  'descriptionformat',
                  userData.data.users[0].descriptionformat
                );
                sessionStorage.setItem('email', userData.data.users[0].email);
                sessionStorage.setItem('firstaccess', userData.data.users[0].firstaccess);
                sessionStorage.setItem('firstname', userData.data.users[0].firstname);
                sessionStorage.setItem('fullname', userData.data.users[0].fullname);
                sessionStorage.setItem('id', userData.data.users[0].id);
                sessionStorage.setItem('lastaccess', userData.data.users[0].lastaccess);
                sessionStorage.setItem('lastname', userData.data.users[0].lastname);
                sessionStorage.setItem('profileimageurl', userData.data.users[0].profileimageurl);
                sessionStorage.setItem(
                  'profileimageurlsmall',
                  userData.data.users[0].profileimageurlsmall
                );
                sessionStorage.setItem('suspended', userData.data.users[0].suspended);
                sessionStorage.setItem('username', userData.data.users[0].username);
                window.location.reload(false);

                navigate('/dashboard');
                // window.location.href = '/dashboard';
              });
            } else {
              setLogincred(false);

              toastError('Email or Password is invalid!');
            }
          } else {
            setLogincred(false);

            alert('server error');
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  useEffect(() => {
    if (sessionStorage.getItem('token') != null) {
      navigate('/dashboard');
    }
  });
  useEffect(() => {
    if (!isValidPassword) {
      setTimeout(() => {
        setPassColor({
          border: 'none',
          boxShadow: primShadow
        });
        setIsValidPassword(true);
      }, 4500);
    }
  }, [isValidPassword]);

  return (
    <Box>
      <img className="main-image" src={mainLogo} />
      <Grid className="boxStyle">
        <Box className="paperStyle">
          <Grid align="left">
            <img className="image" src={logo} />
          </Grid>
          <div className="input-group">
            <Typography sx={{ fontSize: 'normal', color: '#000000' }}>EMAIL</Typography>
            <input
              placeholder="email@example.com"
              value={email}
              className="input"
              type="text"
              onFocus={() =>
                setEmailColor({
                  boxShadow: onFocusShadow
                })
              }
              onMouseLeave={() => {
                setEmailColor({
                  boxShadow: primShadow
                });
              }}
              onMouseEnter={() => {
                setEmailColor({
                  boxShadow: onFocusShadow
                });
              }}
              style={{
                border: 'none',
                boxShadow: emailcolor.boxShadow,
                backgroundColor: '#ffffff'
              }}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <Typography sx={{ fontSize: 'normal', color: '#000000' }}>PASSWORD</Typography>
            <input
              placeholder="●●●●●●●●●●"
              className="input"
              type="password"
              onFocus={() =>
                setPassColor({
                  border: 'none',
                  boxShadow: onFocusShadow
                })
              }
              onMouseLeave={() => {
                setPassColor({
                  border: 'none',
                  boxShadow: primShadow
                });
              }}
              onMouseEnter={() => {
                setPassColor({
                  border: 'none',
                  boxShadow: onFocusShadow
                });
              }}
              style={{
                border: passcolor.border,
                boxShadow: passcolor.boxShadow,
                backgroundColor: '#ffffff'
              }}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <Grid align="center">
            <button type="submit" className="button" onClick={onFormSubmit}>
              {logincred ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 'center'
                  }}>
                  <CircularProgress size={22} />
                </div>
              ) : (
                'SIGN IN'
              )}
            </button>
            <p className="loginor">OR</p>
            <button
              type="submit"
              className="instructor"
              onClick={() => {
                window.open(
                  'https://keyboarding-lms.pescirrus.com/login/login.php?errorcode=4',
                  '_blank'
                );
              }}>
              INSTRUCTOR SIGN IN
            </button>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
export default Login;
